import { FILTER_KEYS, FILTER, OPTION_FILTER_STYLE, TOTAL_OPTION_FITLER } from '@/pages/Subscription/constant';

const renderIdComponent = (id) => (
  <div className='flex flex-col gap-1'>
    <p className='font-bold text-sm'>{id}</p>
  </div>
)

const TYPE_TEXT_COLOR = {
  CREATED: {
    textColor: 'text-purple-secondary',
    bgColor: 'bg-purple-secondary bg-opacity-10'
  },
  CONFIRMED: {
    textColor: 'text-blue-light',
    bgColor: 'bg-blue-light bg-opacity-10'
  },
  CANCELED: {
    textColor: 'text-grey-dark',
    bgColor: 'bg-grey-dark bg-opacity-10'
  },
  UNPAID: {
    textColor: 'text-yellow-secondary',
    bgColor: 'bg-yellow-secondary bg-opacity-10'
  },
  REFUND: {
    textColor: 'text-red-primary',
    bgColor: 'bg-red-primary bg-opacity-10'
  },
  PARTIAL_REFUND: {
    textColor: 'text-red-primary',
    bgColor: 'bg-red-primary bg-opacity-10'
  },
  PAID: {
    textColor: 'text-green-secondary',
    bgColor: 'bg-green-secondary bg-opacity-10'
  },
  CUSTOMER_SUBMITTED: {
    textColor: 'text-blue-light',
    bgColor: 'bg-blue-light bg-opacity-10'
  },
  COMPLETED: {
    textColor: 'text-green-primary',
    bgColor: 'bg-green-primary bg-opacity-10'
  }
}

const OptionFilter = ({
                        index,
                        status,
                        isActive,
                        onClick,
                      }: SubscriptionDetailOptionFilter) => {
  const { id, name } = status;
  const selectedStyle = OPTION_FILTER_STYLE[`${isActive}`];

  const rightBorderStyle =
    index === TOTAL_OPTION_FITLER - 1 ? '' : 'border-r-0';

  return (
    <div
      role="button"
      tabIndex={0}
      onKeyDown={() => onClick(id)}
      onClick={() => onClick(id)}
      className={`flex border border-grey-soft py-2 px-4 cursor-pointer ${rightBorderStyle} ${selectedStyle.button}`}
    >
      <span className="mr-2">{name}</span>
    </div>
  );
};

export const renderFilterSection = ({
                               activeStatus,
                               onClick,
                             }: SubscriptionDetailFilterSection) => (
  <div className="flex justify-between items-center border border-grey-soft border-b-0">
    <div className="flex flex-row p-4 max-w-xs">
      {FILTER_KEYS.map((filterKey, index) => (
        <OptionFilter
          key={FILTER[filterKey].id}
          index={index}
          status={FILTER[filterKey]}
          isActive={activeStatus === FILTER[filterKey].id}
          onClick={onClick}
        />
      ))}
    </div>
    <div><p className='p-4'>20 per page</p></div>
  </div>
);

export const HEADERS = (type) : TableHeader[] => [
  {
    label: `${type} ID`,
    key: 'customId',
  },
  {
    label: 'Created Date',
    key: 'createdAt',
  },
  {
    label: 'Status',
    key: 'status',
  },
]
export const constructTableData = (data) => {
  const tableBody = data.map(booking => {
    const {
      custom_id: id,
      created_at: createdDate,
      status
    } = booking
    return {
      value:
        {
          customId: id,
          createdAt: createdDate,
          status
        }
    }
  })
  const component = {
    customId: (v) => (renderIdComponent(v)),
    createdAt: (v) => (<p>{`${new Date(v).toLocaleString('id-ID', { year: 'numeric', month: '2-digit', day: '2-digit', hour: '2-digit', minute: '2-digit', timeZoneName: 'short' })}`}</p>),
    status: (v) => (<div className={`flex justify-center items-center rounded w-fit py-2 px-4 ${TYPE_TEXT_COLOR[v]?.bgColor} ${TYPE_TEXT_COLOR[v]?.textColor}`}>
      {v}
    </div>)
  }
  return {
    data: tableBody,
    component
  }
}
export const SORT: TableSort = {
  type: 'SERVER',
  handler: () => {},
};
